import type { StageStatus } from '@/types/project'

const CONFIG: Record<StageStatus, { label: string; badge: string; dot: string }> = {
  green: { label: 'Completed', badge: 'bg-green-100 text-green-700', dot: 'bg-stage-green' },
  red: { label: 'Not completed', badge: 'bg-red-100 text-red-700', dot: 'bg-stage-red' },
  na: { label: 'Not applicable', badge: 'bg-slate-100 text-slate-600', dot: 'bg-slate-400' },
}

/** Green = Completed, Red = Not completed, Grey = Not applicable (spec §8).
 *  Colour + text so the state is never conveyed by colour alone. */
export function StatusBadge({ status }: { status: StageStatus }) {
  const { label, badge, dot } = CONFIG[status] ?? CONFIG.red
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium ${badge}`}
    >
      <span aria-hidden className={`h-2 w-2 rounded-full ${dot}`} />
      {label}
    </span>
  )
}
